export function classNames(...classes:any[]) {
  return classes.filter(Boolean).join(' ')
}

export interface Document {
  id: string,
  title: string;
  body: string;
  date: string;
  time: string;
}

export interface ModalProps { 
  isVisible: boolean; 
  onClose: () => void 
}

export type PlanType = {
  id: string;
  planId: string;
  price: string;
  features: {label: string, key: string}[];
};

export type UserPlanType = "basic" | "premium"